<template>
    <div class="content registerAgreement" :class="!isMobile ? 'web' : ''" style="height: calc(100% - 44px)" v-show="show">
    <div id="commitment-box">
      <p id="title">{{title}}</p>
<!--      <div class="t-bar"></div>-->
      <div id="txtBox" v-html="content"></div>
<!--       <div class="t-bar"></div>-->
       <div class="item">
           <div class="btn-group" v-if="isMobile">
               <!-- <button @click="close('cancel')" class="bg-btn register-btn">取消</button> -->
              <xt-button @click="close('confirm')" >确定</xt-button>
          </div>
          <div class="btn-group" v-else style="text-align: center">
              <el-button type="primary" style="width: 50%" @click="close('confirm')">&nbsp;&nbsp;确定&nbsp;&nbsp;</el-button>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import XtButton from "./xtButton";
export default {
  name: 'register-agreement',
  components: {XtButton},
  props: {
    show: {
      type: Boolean
    },
    title: {
      type: String
    },
    content: {
      type: String
    }
  },
  computed: {
    isMobile () {
      return this.$root.isMobile
    }
  },
  methods: {
    close (str) {
      this.$emit('close', str)
    }
  }
}
</script>

<style lang="less" scoped>
.registerAgreement {
  &.web {
    height: auto!important;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 2147483647;
    padding-top: 54px;
    background-color: white;
    bottom: 0;
    overflow: auto;
    #commitment-box {
      max-width: 850px;
      margin: 0 auto;
      height: auto;
      white-space: initial;
    }
  }
  .btn-group {
    margin-top: 30px;
    white-space: nowrap;
    text-align: justify;
    .bg-btn.register-btn {
      color: #333333;
      &::first-line {
        color: white !important;
      }
    }
    .border-btn.register-btn {
      color: #333333;
    }
    .register-btn {
      width: 48%;
      line-height: 36px;
      border-radius: 18px;
    }
  }
  #txtBox p {
    margin-bottom: 0;
    line-height: 2;
    &.index {
      text-indent: 0;
    }
    &.chapter-title {
      text-align: center;
      font-size: 15px;
    }
  }
  #txtBox {
    text-align: left;
    font-size: 14px;
    color: #333333;
    line-height: 25px;
    text-indent: 2em;
    margin-bottom: 30px;
    margin-top: 30px;
  }
  .t-bar {
    width: 60px;
    margin: 0 auto;
    border-bottom: solid 1px #333333;
  }
  #commitment-box {
    position: relative;
    height: 100%;
    overflow: auto;
    margin-bottom: 65px;
    border: none;
    background-color: #fff;
    text-align: center;
    padding: 25px 12px;
  }
  #commitment-title {
    font-size: 18px;
    font-weight: bold;
    line-height: 55px;
    padding-top: 25px;
    margin-top: 0;
    margin-bottom: 0;
    border-bottom: solid 1px #ccc;
    color: #666;
  }
  #title {
    font-size: 25px;
    color: #333333;
    font-weight: bold;
    margin-top: 0;
    margin-bottom: 25px;
  }
}
</style>
